/**
 * Switches for work that's built but not shown yet.
 * Gold Crest (the separate Texas company) stays hidden until every March Products page is done (Jeffrey, 23 Oct 2026).
 * Its To order tab and part-panel line are in components/GoldCrest.tsx and DetailPanel.tsx; flip this to show them.
 */
export const SHOW_GOLD_CREST = false;
